import { useScript } from '#nuxt-scripts/composables/useScript'
import { defineNuxtPlugin } from 'nuxt/app'
import { useScriptGoogleTagManager } from '/app/node_modules/.pnpm/@nuxt+scripts@1.3.9_@oxc-project+types@0.149.0_@types+google.maps@3.58.1_@types+vimeo___32b7d476f04e88115bb2dfb162dda921/node_modules/@nuxt/scripts/dist/runtime/registry/google-tag-manager.js'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const googleTagManager = useScriptGoogleTagManager({"id":"GTM-P8GH7474","scriptOptions":{"trigger":"idle"}})
    return { provide: { scripts: { googleTagManager } } }
  }
})